"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EndAdornmentWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _icon_buttons = require("../../buttons/icon_buttons");
var _close = _interopRequireDefault(require("../../../icons/close"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dropdown_arrow = _interopRequireDefault(require("../../../icons/dropdown_arrow"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var EndAdornment = function EndAdornment(props) {
  var resettable = props.resettable,
    onReset = props.onReset,
    disabled = props.disabled,
    className = props.className,
    readOnly = props.readOnly,
    toggleMenu = props.toggleMenu;
  if (disabled || readOnly) {
    return null;
  }
  return /*#__PURE__*/React.createElement(EndAdornmentWrapper, {
    className: className
  }, resettable && /*#__PURE__*/React.createElement(_icon_buttons.IconButton, {
    "data-provides": 'clear-selection-button',
    icon: _close["default"],
    label: 'Clear Selection',
    size: "sm",
    onClick: function onClick(e) {
      e.stopPropagation();
      onReset();
    }
  }), /*#__PURE__*/React.createElement(_icon_buttons.IconButton, {
    label: 'Toggle flyout',
    "data-provides": 'flyout-toggle-button',
    icon: _dropdown_arrow["default"],
    size: "sm",
    onClick: toggleMenu,
    focusable: false
  }));
};
var EndAdornmentWrapper = exports.EndAdornmentWrapper = _styledComponents["default"].span.withConfig({
  displayName: "end_adornment__EndAdornmentWrapper"
})(["display:flex;align-items:center;padding:0.25rem;"]);
var _default = exports["default"] = EndAdornment;